var render, staticRenderFns
import script from "./device.vue?vue&type=script&lang=ts"
export * from "./device.vue?vue&type=script&lang=ts"
import style0 from "./device.vue?vue&type=style&index=0&id=ef980c40&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef980c40",
  null
  
)

export default component.exports